import { render } from "./InquiryForm.vue?vue&type=template&id=6ca29fc6&scoped=true"
import script from "./InquiryForm.vue?vue&type=script&lang=js"
export * from "./InquiryForm.vue?vue&type=script&lang=js"

import "./InquiryForm.vue?vue&type=style&index=0&id=6ca29fc6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6ca29fc6"

export default script